import { Component } from '@angular/core';

@Component({
  selector: 'app-email-verification-header',
  standalone: true,
  imports: [],
  templateUrl: './email-verification-header.component.html',
  // styleUrl: './email-verification-header.component.scss'
})
export class EmailVerificationHeaderComponent {

}
